/**
 * タブ
 * data-tab を付けた要素をタブ化する
 * サンプル
 *  <div class="l-tab" data-tab>
      <ul class="l-tab__nav" data-tab-nav>
        <li><a class="is-current" href="javascript:void(0);" data-tab-key="1">1のタブ</a></li>
        <li><a href="javascript:void(0);" data-tab-key="2">2のタブ</a></li>
      </ul>
      <div class="l-tab__body" data-tab-body>
        <div data-tab-key="1"> ... </div>
        <div data-tab-key="2"> ... </div>
      </div>
    </div>

 * 最初に表示するタブは、html側でナビとボディーに is-current を付与する
 * 表示/非表示の制御は、is-current クラスで行っている（=CSSでやってる）
 */

export default class Tab {
  constructor(_parm) {
    this.tabs = [...document.querySelectorAll('[data-tab]')];
    this.attr = {
      nav: 'data-tab-nav',
      body: 'data-tab-body',
      key: 'data-tab-key',
    };
    this.currentClass = 'is-current';
  }

  /**
   * タブを切り替える
   * @param {String} key タブのキー
   * @param {Array Element} navLinks 対象のタブのナビリンクの配列
   * @param {Array Element} bodys 対象のタブのボディーの配列
   */
  toggle(key, navLinks, bodys) {
    // 対象のナビリンクとボディーを取得
    const targetNav = navLinks.find(link => link.getAttribute(this.attr.key) === key);
    const targetBody = bodys.find(link => link.getAttribute(this.attr.key) === key);
    // 最初にアクティブクラスリセット
    navLinks.forEach((navLink) => {
      navLink.classList.remove(this.currentClass);
    });
    bodys.forEach((navLink) => {
      navLink.classList.remove(this.currentClass);
    });
    // アクティブクラス付与
    targetNav.classList.add(this.currentClass);
    targetBody.classList.add(this.currentClass);
  }

  /**
   * 全てのタブの全てのナビリンクにイベント付与
   */
  addEvent() {
    this.tabs.forEach((tab) => {
      const navLinks = [...tab.querySelectorAll(`[${this.attr.nav}] [${this.attr.key}]`)];
      const bodys = [...tab.querySelectorAll(`[${this.attr.body}] [${this.attr.key}]`)];
      navLinks.forEach(navLink => {
        navLink.addEventListener('click', (ev) => {
          ev.preventDefault();
          const key = navLink.getAttribute(this.attr.key);
          this.toggle(key, navLinks, bodys);
        });
      });
    });
  }

  init() {
    if (!this.tabs.length) return;
    this.addEvent();
  }
}
